<template>
    <div class="test">
        <h1>Test: {{ passTest }}</h1>
    </div>
</template>

<script>
export default {
    props: {
      passTest: {
        type: String,
        required: true
      }
    },
    data() {
        return {
            //
        }
    },
    methods: {
        //
    },
    mounted() {
        //
    }
}
</script>

<style scoped>
    .test {
        background: #0a53be;
        color: #fff;
    }
</style>
